import { navV3Messages } from '@/components/layout/Navigation/nav-v3/nav-v3.messages';
import { type FooterMoreRowDescriptor } from '@/components/layout/Navigation/sidebar/footer-rail/footer-rail-context';
import { useIsWorkflowsEnabled } from '@/features/flags';
import { useOpenRoutinesSurface } from '@/features/workflows/hooks/useOpenRoutinesSurface';
import { Routines } from '@heidi/design-system/icons';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../mobile/use-mobile-panel';

/**
 * The primary nav More row for Routines, mirroring `RoutinesNavItem`. Routines
 * has no route of its own, so the row opens the Routines surface on select.
 */
export function useRoutinesMoreDescriptor(): FooterMoreRowDescriptor | null {
  const intl = useIntl();
  const isWorkflowsEnabled = useIsWorkflowsEnabled();
  const openRoutines = useOpenRoutinesSurface();
  const { dismissMobileSidebar } = useMobilePanel();

  return useMemo(() => {
    if (!isWorkflowsEnabled) return null;
    return {
      id: 'routines',
      label: intl.formatMessage(navV3Messages.routines),
      icon: <Routines />,
      testId: 'sidebar-link-routines',
      onSelect: () => {
        openRoutines(null);
        dismissMobileSidebar();
      },
    };
  }, [isWorkflowsEnabled, intl, openRoutines, dismissMobileSidebar]);
}
